// extracted by mini-css-extract-plugin
module.exports = {"container":"circular-progress_container__NUxfe","inProgress":"circular-progress_inProgress__2oh1Y","text":"circular-progress_text__J03zt"};